import React, { Fragment, useState } from "react";
import { Grid, Typography, Link } from "@mui/material";
import Project from "../../api/project";
import Header2 from "../../components/Header2/Header2";
import PageTitle from "../../components/pagetitle/PageTitle";
import Scrollbar from "../../components/scrollbar/scrollbar";
import Footer from "../../components/footer/Footer";
import SEO from "../../components/SEO";

const PrivacyPolicy = (props) => {
  const [activeFilter, setActiveFilter] = useState("all");

  const ClickHandler = () => {
    window.scrollTo(10, 0);
  };

  const handleFilterClick = (filter) => {
    setActiveFilter(filter);
  };

  const filteredProjects =
    activeFilter === "all"
      ? Project.slice(9, 18)
      : Project.slice(9, 18).filter(
          (project) => project.category === activeFilter
        );

  return (
    <Fragment>
      <SEO
        title="Privacy Policy | Unified Consultancy Services"
        description="Read the Privacy Policy of Unified Consultancy Services to understand how we collect, use, and protect your personal information on our website and services."
        url="https://www.ufsnetworks.com/PrivacyPolicy"
        image="https://texora.s3.ap-south-1.amazonaws.com/ufs_logo.jpg"
        canonicalUrl="https://www.ufsnetworks.com/PrivacyPolicy"
      />
      <Header2 />
      <main>
        <PageTitle
          pageTitle={"Unified Consultancy Services"}
          pagesub={"Unified Consultancy Services Privacy Policy"}
          pageTop={""}
        />
        <section className="container">
          <Grid container spacing={2} py={4}>
            
            <Grid item sm={12}>
                <Typography variant="h2" fontSize={24} fontWeight={600} mb={.5}>
                    Privacy Policy 
                </Typography>
                <Typography mt={2}> Last Updated: 12-05-2025</Typography>
                <Typography my={1}>Unified Consultancy Services ("we", "our", "us") is committed to protecting your privacy. This Privacy Policy outlines how we collect, use, disclose, and safeguard your personal information when you visit our website or use our services.</Typography>
                <Typography fontWeight={600} mt={2} mb={.5}>1. Information We Collect</Typography>
                <Typography px={2}>We may collect the following types of information:</Typography>
                <Typography fontWeight={600} mt={2} mb={1}>Personal Information</Typography>
                <ul style={{ listStyleType: 'numeric', paddingLeft: '32px', fontSize:'14px', lineHeight:'24px' }}>
                    <li>Name</li>
                    <li>Email address</li>
                    <li>Phone number</li>
                    <li>Job title</li>
                    <li>Company name</li>
                    <li>Address</li>
                </ul>
                <Typography fontWeight={600} my={1}>Technical and Usage Information</Typography>
                <ul style={{ listStyleType: 'numeric', paddingLeft: '32px', fontSize:'14px', lineHeight:'24px' }}>
                    <li>IP address</li>
                    <li>Browser type and version</li>
                    <li>Pages visited and time spent on site</li>
                    <li>Device type and operating system</li>
                    <li>Cookies and tracking data</li>
                </ul>
                <Typography fontWeight={600} my={1}>2. How We Use Your Information</Typography>
                <Typography px={2} mb={1}>We may use your information to:</Typography>
                <ul style={{ listStyleType: 'numeric', paddingLeft: '32px', fontSize:'14px', lineHeight:'24px' }}>
                    <li>Provide, operate, and maintain our services</li>
                    <li>Respond to inquiries or support requests</li>
                    <li>Improve our website and user experience</li>
                    <li>Send newsletters, marketing, or promotional content (with your consent)</li>
                    <li>Comply with legal obligations</li>
                </ul>

                <Typography fontWeight={600} my={1}>3. Cookies and Tracking Technologies</Typography>
                <Typography px={2} mb={1}>We use cookies and similar technologies to:</Typography>
                <ul style={{ listStyleType: 'numeric', paddingLeft: '32px', fontSize:'14px', lineHeight:'24px' }}>
                    <li>Understand user behavior</li>
                    <li>Customize your experience</li>
                    <li>Analyze website traffic</li>
                </ul>
                <Typography px={2} mb={2}>You can modify your browser settings to refuse or delete cookies. However, some features of the site may not function properly without them.</Typography>

                <Typography fontWeight={600} my={1}>4. Sharing Your Information</Typography>
                <Typography px={2} mb={1}>We do not sell or rent your personal data. We may share it with:</Typography>
                <ul style={{ listStyleType: 'numeric', paddingLeft: '32px', fontSize:'14px', lineHeight:'24px' }}>
                    <li>Trusted third-party service providers (e.g., email, analytics)</li>
                    <li>Legal or regulatory authorities, if required by law</li>
                    <li>Business partners (only with your explicit consent)</li>
                </ul>

                <Typography fontWeight={600} my={1}>5. Data Security</Typography>
                <Typography px={2} mb={2}>We take reasonable administrative, technical, and physical safeguards to protect your personal data from unauthorized access, disclosure, or misuse.</Typography>

                <Typography fontWeight={600} my={1}>6. Your Rights</Typography>
                <Typography px={2} mb={1}>Depending on your jurisdiction, you may have the right to:</Typography>
                <ul style={{ listStyleType: 'numeric', paddingLeft: '32px', fontSize:'14px', lineHeight:'24px' }}>
                    <li>Access the personal data we hold about you</li>
                    <li>Request correction or deletion of your information</li>
                    <li>Object to or restrict certain types of processing</li>
                    <li>Withdraw consent where processing is based on it</li>
                </ul>
                <Typography px={2} mb={2}>To exercise any of these rights, please contact us at <b>info@ufsnetworks.com</b></Typography>

                <Typography fontWeight={600} my={1}>7. Third-Party Links</Typography>
                <Typography px={2} mb={2}>Our website may contain links to third-party websites. We are not responsible for the privacy practices or content of such websites.</Typography>

                <Typography fontWeight={600} my={1}>8. Children's Privacy</Typography>
                <Typography px={2} mb={2}>Our services are not intended for children under 13. We do not knowingly collect personal information from children.</Typography>

                <Typography fontWeight={600} my={1}>9. Updates to This Privacy Policy</Typography>
                <Typography px={2} mb={2}>We may update this Privacy Policy periodically. When we do, we will revise the “Last Updated” date at the top of this page.</Typography>

                <Typography fontWeight={600} my={1}>10. Contact Us</Typography>
                <Typography px={2} mb={1}>If you have any questions about this Privacy Policy or how we handle your data, please contact us at:</Typography>
                <Typography fontWeight={600} px={2} mb={.5}>Unified Consultancy Services</Typography>
                <Typography px={2} mb={0}>Email: info@ufsnetworks.com</Typography>
                <Typography px={2} mb={1}>Website: <a href="https://ufsnetworks.com">ufsnetworks.com</a></Typography>


            </Grid>
          </Grid>
        </section>
      </main>
      <Footer />
      <Scrollbar />
    </Fragment>
  );
};

export default PrivacyPolicy;
